module.exports = __webpack_public_path__ + "media/src/images/icons/help/primary-a5d3d2edf6f57870ee8ade95655f93c4.svg";